import React, { useState, useEffect } from 'react';
import { fetchTechniciansByTechService } from '../services/techniciansService';
import './TechnicianSelectStep.css';

const TechnicianSelectStep = ({
  selectedTechnician,
  setSelectedTechnician,
  techServiceId,
  loading: parentLoading = false,
  error: parentError = ''
}) => {
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (techServiceId) {
      loadTechnicians();
    } else {
      setTechnicians([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [techServiceId]);

  const loadTechnicians = async () => {
    if (!techServiceId) return;
    
    setLoading(true);
    setError('');
    try {
      const response = await fetchTechniciansByTechService(techServiceId, { aktif: true });
      const list = response?.veri?.teknisyenler || response?.data?.teknisyenler || response?.veri || [];
      setTechnicians(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error('Teknisyen listesi yükleme hatası:', err);
      setError('Teknisyenler yüklenemedi');
      setTechnicians([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTechnicianSelect = (technician) => {
    setSelectedTechnician(technician);
  };

  if (parentLoading || loading) {
    return (
      <div className="technician-select-step">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <div className="loading-text">Teknisyenler yükleniyor...</div>
        </div>
      </div>
    );
  }

  if (parentError || error) {
    return (
      <div className="technician-select-step">
        <div className="error-state">
          <i className="fas fa-exclamation-circle"></i>
          <span>{parentError || error || 'Teknisyenler yüklenemedi'}</span>
        </div>
      </div>
    );
  }

  if (technicians.length === 0) {
    return (
      <div className="technician-select-step">
        <div className="empty-state">
          <i className="fas fa-user-slash"></i>
          <div className="empty-state-text">Bu teknik servise ait aktif teknisyen bulunamadı</div>
        </div>
      </div>
    );
  }

  return (
    <div className="technician-select-step">
      <div className="step-header">
        <h3>Teknisyen Seçiniz</h3>
        <p className="step-description">Randevu için bir teknisyen seçiniz</p>
      </div>

      <div className="technician-list">
        {technicians.map((technician) => {
          const technicianId = technician.id || technician._id;
          const isSelected = selectedTechnician && (selectedTechnician.id === technicianId || selectedTechnician._id === technicianId);
          
          // Teknisyen ismini farklı alan adlarından al
          const ad = technician.ad || technician.name || technician.adi || '';
          const soyad = technician.soyad || technician.surname || technician.soyadi || '';
          const technicianName = `${ad} ${soyad}`.trim() || 'İsimsiz';
          const username = technician.kullaniciAdi || technician.username || '';

          return (
            <div
              key={technicianId}
              role="button"
              tabIndex={0}
              aria-label={`Teknisyen seç: ${technicianName} ${username ? `@${username}` : ''}`}
              className={`technician-card ${isSelected ? 'selected' : ''}`}
              onClick={() => handleTechnicianSelect(technician)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleTechnicianSelect(technician); } }}
            >
              <div className="technician-card-header">
                <div className="technician-avatar">
                  <i className="fas fa-user"></i>
                </div>
                <div className="technician-info">
                  <div className="technician-name">{technicianName}</div>
                  {username && (
                    <div className="technician-username">
                      <span>@{username}</span>
                    </div>
                  )}
                </div>
                {isSelected && (
                  <div className="technician-selected-icon">
                    <i className="fas fa-check-circle"></i>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TechnicianSelectStep;
